<template>
  <div v-if="skill.userUuid" class="suggest-item" @click.stop="openSkill">
    <div class="avatar">
      <fps-img :src="`${skill.avatarImageUrl}?d=600x600`" />
      <fps-voice
        v-if="skill.voiceUrl"
        class="voice"
        :src="skill.voiceUrl"
        :init-seconds="skill.voiceSecond"
        :color="sexVoiceColor"
        control
      />
    </div>
    <div class="suggest">
      <div class="top">
        <div class="name">{{ skill.nickname }}</div>
        <div v-if="sex" class="sexage" :class="sex">
          <fps-icon v-if="sex" :type="sex + '2'" :size="12" />
          <span v-if="skill.age">{{ skill.age }}</span>
        </div>
      </div>
      <template v-if="user.id">
        <router-link
          class="game"
          :to="`/player-list/${skill.gameId}`"
          @click.native.stop
        >
          {{ user.gameName }}
        </router-link>
        <div class="comment">
          <p>@{{ user.commentatorName }}：“{{ user.content }}”</p>
        </div>
      </template>
      <div class="price-info">
        <template v-if="computedPrice">
          <div class="price-normal">
            <span>{{ computedPrice }}</span> {{$t('upgrade_page_views_home_suggest_item_4')}}/{{
              skill.salesUnit | salesUnitTranslate
            }}
          </div>
          <div class="price-origin">
            {{ skill.salesPrice }}{{$t('upgrade_page_views_home_suggest_item_4')}}/{{ skill.salesUnit | salesUnitTranslate }}
          </div>
        </template>
        <template v-else>
          <div class="price-normal">
            <span>{{ skill.salesPrice }}</span> {{$t('upgrade_page_views_home_suggest_item_4')}}/{{
              skill.salesUnit | salesUnitTranslate
            }}
          </div>
        </template>
      </div>
    </div>
    <SkillDetail
      v-if="initSkill"
      v-model="showSkill"
      :info="item.playerSkill"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SkillDetail from '@/components/SkillDetail';

export default {
  components: {
    SkillDetail
  },
  data() {
    return {
      initSkill: false,
      showSkill: false
    };
  },
  props: {
    item: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  computed: {
    ...mapGetters(['adminUuid']),
    skill() {
      return this.item.playerSkill || {};
    },
    isAdmin() {
      return this.adminUuid === this.skill.userUuid;
    },
    sex() {
      const sex = this.skill.sex;
      const trans = {
        Male: 'boy',
        Female: 'girl'
      };
      return sex ? trans[sex] : '';
    },
    sexVoiceColor() {
      const sex = this.skill.sex;
      const trans = {
        Male: '#5362EC',
        Female: '#EC5375'
      };
      return sex ? trans[sex] : '';
    },
    user() {
      return this.item.orderComment || {};
    },
    computedPrice() {
      return this.$util.computedPrice(this.skill);
    }
  },
  methods: {
    openSkill() {
      const { playerSkill } = this.item;
      this.$util.openWindow(
        `/player-detail/${playerSkill.userUuid}?skillId=${playerSkill.id}`
      );
    }
  }
};
</script>

<style lang="scss" scoped>
.suggest-item {
  @include flex;
  position: relative;
  overflow: hidden;
  background: linear-gradient(180deg, #5c5874 0%, #39364d 100%);
  border-radius: 4px;
  cursor: pointer;
  .avatar {
    flex-shrink: 0;
    position: relative;
    width: 232px;
    height: 232px;
    .voice {
      position: absolute;
      left: 12px;
      bottom: 12px;
      width: 136px;
      height: 40px;
    }
  }
  .suggest {
    flex-grow: 1;
    @include flex(flex-start, flex-start, column);
    overflow: hidden;
    height: 232px;
    padding: 16px;
    background: url('~@/assets/image/background/home-suggest-fire.png') right
      bottom no-repeat;
    background-size: auto 208px;
    > * {
      flex-shrink: 0;
    }
    .top {
      @include flex(flex-start);
      max-width: 100%;
      .name {
        line-height: 28px;
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        @include ellipsis;
        cursor: text;
      }
      .sexage {
        flex-shrink: 0;
        @include flex;
        margin-left: 4px;
        padding: 0 4px 1px;
        height: 18px;
        border-radius: 20px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        &.boy {
          background-color: #81acff;
        }
        &.girl {
          background-color: #ff81b6;
        }
        span {
          margin-left: 2px;
        }
      }
    }
    .game {
      margin-top: 8px;
      height: 28px;
      line-height: 28px;
      padding: 0 16px;
      background-color: #68647d;
      border-radius: 4px;
      color: #fff;
      font-size: 14px;
      &:hover {
        background-color: $color-gray-2;
      }
    }
    .comment {
      margin-top: 16px;
      height: 66px;
      line-height: 22px;
      color: rgba($color: #fff, $alpha: 0.8);
      font-size: 14px;
      text-align: left;
      @include ellipsis(3);
      cursor: text;
    }
    .price {
      &-info {
        @include flex(flex-start, flex-end);
        margin-top: 24px;
        height: 22px;
        padding: 5px 0;
        color: #fab93c;
        font-size: 12px;
        cursor: text;
        span {
          line-height: 20px;
          font-size: 24px;
          font-weight: 600;
          vertical-align: bottom;
        }
      }
      &-origin {
        margin-left: 8px;
        color: rgba(140, 148, 170, 0.5);
        font-weight: 500;
        text-decoration: line-through;
      }
    }
  }
}

@media screen and (max-width: 599px) {
  .suggest-item {
    flex-shrink: 0;
    width: 308px !important;
    + .suggest-item {
      margin-left: 8px;
    }
    .avatar {
      width: 132px;
      height: 132px;
      .voice {
        left: 8px;
        bottom: 8px;
        transform: scale(0.853);
        transform-origin: left bottom;
      }
    }
    .suggest {
      height: 132px;
      padding: 6px 2px;
      background-size: auto 118px;
      .top {
        height: 20px;
        .name {
          font-size: 14px;
        }
        .sexage {
          height: 16px;
        }
      }
      .game {
        margin-top: 4px;
        padding: 0 8px;
        height: 24px;
        line-height: 24px;
        font-size: 12px;
      }
      .comment {
        margin-top: 8px;
        font-size: 12px;
        height: 36px;
        line-height: 18px;
      }
      .price-info {
        margin-top: 2px;
        height: auto;
        font-size: 12px;
        display: flex;
        align-items: center;
        .price-normal {
          display: flex;
          align-items: center;
        }
        span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
